import { render, staticRenderFns } from "./LexonNumerationComponent.vue?vue&type=template&id=2faaea22&scoped=true&lang=pug"
import script from "./LexonNumerationComponent.vue?vue&type=script&lang=ts"
export * from "./LexonNumerationComponent.vue?vue&type=script&lang=ts"
import style0 from "./LexonNumerationComponent.vue?vue&type=style&index=0&id=2faaea22&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2faaea22",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2faaea22')) {
      api.createRecord('2faaea22', component.options)
    } else {
      api.reload('2faaea22', component.options)
    }
    module.hot.accept("./LexonNumerationComponent.vue?vue&type=template&id=2faaea22&scoped=true&lang=pug", function () {
      api.rerender('2faaea22', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/forms/fields/LexonNumeration/LexonNumerationComponent.vue"
export default component.exports